





















































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class BorderController extends Vue 
{
    @Prop() borderColor! : ColorConstruct;

    static readonly PRINT_BORDER_ON = "枠あり印刷ON";
    static readonly PRINT_BORDER_OFF = "枠あり印刷OFF";

    private get borderVisibleText()
    {
        return this.$store.getters.userConfig.isPrintBorder ? BorderController.PRINT_BORDER_ON : BorderController.PRINT_BORDER_OFF;
    }

    private changeBorderVisible()
    {
        var parameter = {};
        parameter["isVisible"] = !this.$store.getters.userConfig.isPrintBorder;
        this.$emit("doCommand", "setPrintBorderVisible", parameter);
    }

    private changeColor(hex : string)
    {
        var color = ColorConstruct.createFromHex(hex);
        var parameter = {};
        parameter["color"] = color;
        this.$emit("doCommand", "changeBorderColor", parameter);
    }

    private requestColor()
    {
        var parameter = {};
        parameter["propertyName"] = "borderColor";
        parameter["type"] = "color";
        var hex = this.borderColor.hex;
        if(hex.substr(0, 1) == "#") { hex = hex.substr(1, 6); }
        parameter["currentValue"] = hex;
        this.$emit("doCommand", "sendNativeEvent", { message : "request_print_setting", parameter : parameter });
    }
}
